import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class SizeGuideDrawer extends UcoastEl {
    static htmlSelector = 'size-guide-drawer'
    static selectors = {
        overlay: '[data-uc-size-guide-drawer-overlay]',
        toggle__link: '.size-guide__toggle',
        container: '#SizeGuideDrawer',
        inner: '[data-uc-size-guide-drawer-inner]',
    }
    activeElement?: HTMLElement
    constructor() {
        super()
    }

    override connectedCallback(): void {
        this.addEventListener(
            'keyup',
            (evt) => evt.code === 'Escape' && this.close()
        )
        this.getOverlay().addEventListener('click', this.close.bind(this))
        this.setDrawerLinkAccessibility()
    }

    getOverlay() {
        return q.rs(SizeGuideDrawer.selectors.overlay, this)
    }

    setDrawerLinkAccessibility() {
        const toggle__link = q.rs(SizeGuideDrawer.selectors.toggle__link)
        toggle__link.setAttribute('role', 'button')
        toggle__link.setAttribute('aria-haspopup', 'dialog')
        toggle__link.addEventListener('click', (event) => {
            event.preventDefault()
            this.open(toggle__link)
        })
        toggle__link.addEventListener('keydown', (event) => {
            if (event.code?.toUpperCase() === 'SPACE') {
                event.preventDefault()
                this.open(toggle__link)
            }
        })
    }

    open(triggeredBy?: HTMLElement) {
        if (triggeredBy) this.setActiveElement(triggeredBy)
        setTimeout(() => {
            this.classList.add('animate', 'active')
        }, 1)
        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = q.rs(SizeGuideDrawer.selectors.container, this)
                const focusElement = q.os(SizeGuideDrawer.selectors.inner, this)
                window.TsDOM.trapFocus(containerToTrapFocusOn, focusElement)
                void window.Ucoast.mediaManager.playAllInContainer(this)
            },
            { once: true }
        )
        document.body.classList.add('overflow-hidden')
    }

    close() {
        this.classList.remove('active')
        window.TsDOM.removeTrapFocus(this.activeElement)
        document.body.classList.remove('overflow-hidden')
    }

    setActiveElement(element: Element | null) {
        if (!element) throw new Error('Active element is required')
        this.activeElement = element as HTMLElement
    }
}